// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CmsPageQueryVariables = Types.Exact<{
  filter: Types.ContentPageConnectionFilter;
}>;


export type CmsPageQuery = { __typename?: 'Query', content?: { __typename?: 'Content', id: string, pages?: { __typename?: 'ContentPageConnection', totalCount?: number, edges?: Array<{ __typename?: 'ContentPageEdge', node?: { __typename: 'ContentPage', id: string, name?: string, mainBlock?: string, mainBlockPlainText?: string, handle?: string, sectionHandle?: string, participating?: boolean, smallImage?: string, mediumImage?: string, largeImage?: string, terms?: string, title?: string, summary?: string, paths?: string, link?: string } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string, hasNextPage: boolean } } } };

export type CmsPageFragment = { __typename: 'ContentPage', id: string, name?: string, mainBlock?: string, mainBlockPlainText?: string, handle?: string, sectionHandle?: string, participating?: boolean, smallImage?: string, mediumImage?: string, largeImage?: string, terms?: string, title?: string, summary?: string, paths?: string, link?: string };

export type CmsNodeFragment = { __typename?: 'ContentPageEdge', node?: { __typename: 'ContentPage', id: string, name?: string, mainBlock?: string, mainBlockPlainText?: string, handle?: string, sectionHandle?: string, participating?: boolean, smallImage?: string, mediumImage?: string, largeImage?: string, terms?: string, title?: string, summary?: string, paths?: string, link?: string } };

export const CmsPageFragmentDoc = /*#__PURE__*/ gql`
    fragment CmsPageFragment on ContentPage {
  id
  name
  mainBlock
  mainBlockPlainText
  handle
  sectionHandle
  participating
  smallImage
  mediumImage
  largeImage
  terms
  title
  summary
  paths
  link
  __typename
}
    `;
export const CmsNodeFragmentDoc = /*#__PURE__*/ gql`
    fragment CmsNodeFragment on ContentPageEdge {
  node {
    ...CmsPageFragment
  }
}
    ${CmsPageFragmentDoc}`;
export const CmsPageQueryDocument = /*#__PURE__*/ gql`
    query CmsPageQuery($filter: ContentPageConnectionFilter!) {
  content {
    id
    pages(filter: $filter) {
      edges {
        ...CmsNodeFragment
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
}
    ${CmsNodeFragmentDoc}`;
export function useCmsPageQuery(baseOptions: Apollo.QueryHookOptions<CmsPageQuery, CmsPageQueryVariables> & ({ variables: CmsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsPageQuery, CmsPageQueryVariables>(CmsPageQueryDocument, options);
      }
export function useCmsPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsPageQuery, CmsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsPageQuery, CmsPageQueryVariables>(CmsPageQueryDocument, options);
        }
export function useCmsPageQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CmsPageQuery, CmsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CmsPageQuery, CmsPageQueryVariables>(CmsPageQueryDocument, options);
        }
export type CmsPageQueryHookResult = ReturnType<typeof useCmsPageQuery>;
export type CmsPageQueryLazyQueryHookResult = ReturnType<typeof useCmsPageQueryLazyQuery>;
export type CmsPageQuerySuspenseQueryHookResult = ReturnType<typeof useCmsPageQuerySuspenseQuery>;
export type CmsPageQueryQueryResult = Apollo.QueryResult<CmsPageQuery, CmsPageQueryVariables>;